import React from 'react';
import PropTypes from 'prop-types';

import { HeadingBlock } from './styles/HeadingBlock';

function OpenFormHeading({ children, className }) {
  return (
    <HeadingBlock className={className}>
      {children}
    </HeadingBlock>
  );
}

OpenFormHeading.defaultProps = {
  className: undefined,
};

OpenFormHeading.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default OpenFormHeading;
